import { render, staticRenderFns } from "./QuickNav.vue?vue&type=template&id=3c2aea58&scoped=true&"
import script from "./QuickNav.vue?vue&type=script&lang=ts&"
export * from "./QuickNav.vue?vue&type=script&lang=ts&"
import style0 from "./QuickNav.vue?vue&type=style&index=0&id=3c2aea58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2aea58",
  null
  
)

export default component.exports